<template>
  <Mmask @close="close" :class="flag ? 'VH' : 'VW'">
    <div class="lantitle">
      <span>Language</span>
    </div>
    <div class="lanList">
      <div
        class="item"
        v-for="(value, name) in lanList"
        :key="name"
        :class="lan == name ? 'active' : ''"
        @click="chose(name, value)"
      >
        {{ value }}
      </div>
      <div class="item empty"></div>
    </div>
  </Mmask>
</template>

<script>
import Mmask from "@/components/mask";
export default {
  components: {
    Mmask,
  },
  data() {
    return {
      lanList: {
        en: "EN",
        // es: "ES",
        ar: "AR",
        mm: "MM",
        my: "MY",
        kh: "KH",
        // pt_BR: "BR",
        id: "ID",
        ph: "PH"
      },
    };
  },
  props: ["lan", "flag"],
  methods: {
    close() {
      this.$emit("close");
    },
    chose(name, value) {
      if (name == "ar") {
        document.getElementById("app").classList.add("ar");
      } else {
        document.getElementById("app").classList.remove("ar");
      }
      this.$emit("chose", name, value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/mask.scss";
</style>
